import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Hammer, Trash2 } from 'lucide-react';
export function SolutionIntro() {
  return <section className="py-20 bg-[#C8102E] text-white" data-id="element-480">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-481">
        <div className="text-center max-w-4xl mx-auto" data-id="element-482">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-483">
            <span className="uppercase tracking-widest font-bold text-red-200 text-sm mb-4 block" data-id="element-484">
              Introducing the One-Call Cleanout
            </span>
            <h2 className="text-4xl md:text-6xl font-bold mb-8 drop-shadow-md" data-id="element-485">
              JOSE'S FULL-SERVICE REMOVAL SYSTEM
            </h2>
            <p className="text-xl md:text-2xl text-red-50 font-medium leading-relaxed mb-12" data-id="element-486">
              Jose's Junk Removal is not your average junk hauler. We are
              Monterey's only true full-service removal crew — handling
              everything from a single old mattress to a complete construction
              site cleanout.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8 text-left" data-id="element-487">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-white/10 p-6 rounded-lg backdrop-blur-sm border border-white/20" data-id="element-488">
              <Trash2 size={32} className="mb-4 text-white" data-id="element-489" />
              <h3 className="text-xl font-bold mb-2" data-id="element-490">Complete Disposal</h3>
              <p className="text-red-100" data-id="element-491">
                From backyard sheds to full hoarder properties, we clear it all
                so you don't have to coordinate multiple companies.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-white/10 p-6 rounded-lg backdrop-blur-sm border border-white/20" data-id="element-492">
              <Hammer size={32} className="mb-4 text-white" data-id="element-493" />
              <h3 className="text-xl font-bold mb-2" data-id="element-494">Light Demolition</h3>
              <p className="text-red-100" data-id="element-495">
                We don't just haul. We break down sheds, fences, and small
                structures before removing the debris.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-white/10 p-6 rounded-lg backdrop-blur-sm border border-white/20" data-id="element-496">
              <Shield size={32} className="mb-4 text-white" data-id="element-497" />
              <h3 className="text-xl font-bold mb-2" data-id="element-498">One Team. One Call.</h3>
              <p className="text-red-100" data-id="element-499">
                Stop making a dozen phone calls. We handle every piece of the
                job from start to finish.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}